"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCROLL_OFFSET_MOBILE = exports.SCROLL_OFFSET = exports.RETURN_TO_TOP = exports.JUMP_TO = void 0;
var JUMP_TO = 'jump to';
exports.JUMP_TO = JUMP_TO;
var RETURN_TO_TOP = 'Return to Top';
exports.RETURN_TO_TOP = RETURN_TO_TOP;
var SCROLL_OFFSET = 100;
exports.SCROLL_OFFSET = SCROLL_OFFSET;
var SCROLL_OFFSET_MOBILE = 210;
exports.SCROLL_OFFSET_MOBILE = SCROLL_OFFSET_MOBILE;